import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import StickyBook from "@/components/site/StickyBook";
import CartDrawer from "@/components/site/CartDrawer";
import ScrollToTop from "@/components/site/ScrollToTop";
import useScrollReveal from "@/hooks/useScrollReveal";

export default function Layout() {
  const location = useLocation();
  useScrollReveal(location.pathname);

  return (
    <div className="App min-h-screen flex flex-col" data-testid="app-root">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyBook />
      <CartDrawer />
    </div>
  );
}
